module.exports = __webpack_public_path__ + "img/network-icon.70b964e3.svg";